var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',[_c('div',{staticClass:"w-full d-flex justify-center"},[_c('div',{staticClass:"loading-box d-flex align-center flex-column pa-4"},[_c('v-progress-circular',{staticClass:"mr-2",attrs:{"width":"5","size":_vm.size,"color":"primary","indeterminate":""}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }